import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'

export const ScrollContainer = styled.div`
  position: relative;
  width: 100%;
`

export const TonesWrapper = styled.div`
  display: flex;
  gap: 6px;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 0;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const ToneOption = styled.button<{ $isSelected?: boolean }>`
  padding: 4px 6px;
  border-radius: 4px;
  border: 1px solid;
  background-color: ${COLORS.white};
  border-color: ${COLORS.border};
  color: ${COLORS.secondarySemiDark};
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;

  ${({ $isSelected }) =>
    $isSelected
      ? css`
          background-color: ${COLORS.primaryLight};
          border-color: ${COLORS.primaryDark};
          color: ${COLORS.secondaryDark};
        `
      : css`
          &:hover {
            border-color: ${COLORS.secondarySemiLight};
          }
        `}
`
